module.exports = __webpack_public_path__ + "public/SiteImages/createListImage.svg?f9884d0f";